import { Observable } from 'rxjs/Observable';

// Classes.
import { ViewData } from './view-data';
import { CategoryItem } from '../fetching/types/category.item';
import { ResponseData } from '../fetching/wa-response/wa-api-response';

// Providers.
import { LoggerService } from '../logger/logger-service';
import { DataFetchService } from '../wa-services/data-fetch-service';
import { DatabaseService } from '../wa-services/database-service';
import { FactoryService } from '../wa-services/factory-service';
import { WaHelperService } from '../wa-services/wa-helper-service';

// Interfaces.
import { LocatorInterface } from '../interfaces/locator.interface';
import { ViewDataConfigStruct } from '../interfaces/view-data.interface';
import { CompetitionDisciplines } from '../fetching/types/competition-disciplines.item';
import { CompetitionLevelsItem } from '../fetching/types/competition-levels.item';


export class CompetitionLevelsVD extends ViewData<CompetitionLevelsItem> {

    constructor(
        protected logger: LoggerService,
        protected fetchSrvc: DataFetchService,
        protected db: DatabaseService,
        protected factory: FactoryService,
        protected _helper: WaHelperService,
        protected _locator: LocatorInterface
    ) {
        super(logger, db, _locator);
    }

    public configureView() {
        let viewDataConf = new ViewDataConfigStruct();
        viewDataConf.maxAge = 3600 * 24 * 7;
        viewDataConf.expectedItems = 'ALL';
        this.applyConfiguration(viewDataConf);
    }

    public updateData(): Observable<ResponseData> {
        return this.fetchSrvc.requestCompetitionLevels(this.locator, this.pageInfo());
    }

    public mapItem(rawItem: any): CompetitionLevelsItem {
        return this.factory.newCompetitionLevels(rawItem);

    }

}
